export default "__VITE_ASSET__Dv$X4nmn__"